/* eslint-disable import/no-unresolved */
import '@notifications/index.js';

$(() => $('html').trigger('consumer.dependencies.notifications.loaded'));
